/**
 *  FLOAT_ELEMENT 레이아웃 별 z-index
 * @returns {number} 2
 *  */
export const FLOAT_ELEMENT: number = 2;

/**
 *  HEADER_INDEX 레이아웃 별 z-index
 * @returns {number} 3
 *  */
export const HEADER_INDEX: number = 3;

/**
 *  POPUP_INDEX 레이아웃 별 z-index
 * @returns {number} 4
 *  */
export const POPUP_INDEX: number = 4;

/**
 *  TOP_POPUP_INDEX 레이아웃 별 z-index
 * @returns {number} 5
 *  */
export const TOP_POPUP_INDEX: number = 5;
